import CryptoJS from "crypto-js";
import React from "react";
import Image from "next/image";
import Link from "next/link";

export function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

export function AesDecrypt(data: any) {
  const key = "B?E(H+MbQeThWmZq4t7w!z$C&F)J@NcR";
  const iv = "AEF$#DQER@#R@#f3";
  var reb64 = CryptoJS.enc.Hex.parse(data);
  var bytes = reb64?.toString(CryptoJS.enc.Base64);
  let cipher = CryptoJS.AES.decrypt(bytes, CryptoJS.enc.Utf8.parse(key), {
    iv: CryptoJS.enc.Utf8.parse(iv),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return cipher.toString(CryptoJS.enc.Utf8);
}

export function AesEncrypt(data: any) {
  const key = "B?E(H+MbQeThWmZq4t7w!z$C&F)J@NcR";
  const iv = "AEF$#DQER@#R@#f3";
  let cipher = CryptoJS.AES.encrypt(
    JSON.stringify(data),
    CryptoJS.enc.Utf8.parse(key),
    {
      iv: CryptoJS.enc.Utf8.parse(iv), // parse the IV
      padding: CryptoJS.pad.Pkcs7,
      mode: CryptoJS.mode.CBC,
    }
  );

  // e.g. B6AeMHPHkEe7/KHsZ6TW/Q==
  let b64 = cipher.toString();
  let e64 = CryptoJS.enc.Base64.parse(b64);
  let eHex = e64.toString(CryptoJS.enc.Hex);
  return eHex;
}

export const funcForDecrypt = async (dataToBeDecrypt: any) => {
  const response = AesDecrypt(dataToBeDecrypt);
  //
  return response;
};

export const funForAesEncrypt = async (dataToBeEncrypt: any) => {
  const response = await AesEncrypt(dataToBeEncrypt);
  //
  return response;
};

export function ParseFloat(str: any, val: any) {
  str = str.toString();
  if (Number.isInteger(Number(str))) {
    return Number(str);
  } else {
    str = str.slice(0, str.indexOf(".") + val + 1);
  }
  return Number(str);
}

export function formatString(inputString: string): string {
  return inputString
    .toLowerCase()
    .split(" ")
    .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const Card = ({ title, description, imageUrl, linkTo }: any) => {
  const formattedDescription = description.replace(/LIMITED/g, "LIMITED<br />");

  return (
    <Link href={linkTo}>
      <div className="py-6 sm:min-h-[110px] overflow-hidden flex flex-col items-center">
        <Image
          className="mb-1"
          src={imageUrl}
          alt={title}
          width={30}
          height={30}
          style={{
            maxWidth: "100%",
            height: "auto"
          }} />
        <div className="bold text-base mt-2 text-white">{title}</div>
        <div
          className="px-4 py-2 text-center text-white"
          dangerouslySetInnerHTML={{ __html: formattedDescription }}
        />
      </div>
    </Link>
  );
};

type InputType = "text" | "number" | "email" | "password" | "date" | "textarea" | "tel";
interface InputProps {
  type?: InputType;
  autoComplete?: string;
  required?: boolean;
  label?: string;
  formik: any;
  name: string;
  onblur?: any;
  placeholder?: any;
  extra?: object;
}

const FormInput = ({
  type,
  autoComplete,
  required,
  label,
  name,
  formik,
  placeholder,
  onblur,
  extra,
}: InputProps) => {
  return (
    <div className={styles.p0}>
      {label && (
        <label htmlFor="email" className={styles.p1}>
          {label}
        </label>
      )}
      <div className={styles.p4}>
        <input
          id={name}
          name={name}
          type={type || "text"}
          onChange={formik.handleChange}
          onBlur={onblur}
          value={formik.values[name]}
          autoComplete={autoComplete}
          required={required || false}
          placeholder={placeholder || `${label}${required ? "" : ""}`}
          className={styles.p2}
          {...extra}
        />
        {formik.touched[name] && formik.errors[name] ? (
          <span className={styles.p3}>{formik.errors[name]}</span>
        ) : null}
      </div>
    </div>
  );
};
const styles = {
  p0: "mb-2",
  p1: "block text-sm mb-2 text-white ",
  p2: "block w-full  placeholder:text-gray-500 text-white rounded-3xl bg-theme  px-4 py-2 focus:outline-none focus:bg-theme  border-1  focus:ring-0 focus:border-b",
  // p2: "appearance-none placeholder:text-gray-500 block w-full sm:w-2/3 px-3 py-2 border-0 rounded-md theme-shadow placeholder-gray-400 focus:border-yellow-600 focus:ring-1 focus:ring-yellow-600 sm:text-sm",
  p3: "text-red-500 text-sm",
  p4: "mt-1",
};
export default FormInput;

const displayValue = (lable: any) => {
  switch (lable) {
    case 'Coin':
      return "Coin Type"
    case 'Coin Weight':
      return "Total Weight"
    case 'Coin Quantity':
      return "Coin Quantity"
    case "Making Charges (Incl. 18% GST)":
      return "Making Charges (Incl. 18% GST)"
    default:
      return lable;
  }

}

export const renderPriceBreakdownItem = ({ label, value, index }: any) => (
  <>
    <div key={index} className="mb-2 flex justify-between">
      <span>{displayValue(label)}</span>
      <span>{value}</span>
    </div>
    <hr
      className="my-1 border-t border-gray-300"
      style={{
        backgroundImage:
          "linear-gradient(to right, #d2d6dc 50%, transparent 50%)",
        backgroundSize: "0.3rem 2px",
        backgroundRepeat: "repeat-x",
        border: "none",
        height: "1px",
      }}
    />
  </>
);

export const renderPriceBreakdownItemCart = ({
  label,
  value,
  index,
  imageUrl,
}: any) => (
  <div>
    <div className="justify-between flex items-center">
      <div key={index} className="mb-1 flex items-center">
        {imageUrl && (
          <div className="mr-1">
            <img src={imageUrl} alt={label} className="w-10 h-10" />
          </div>
        )}
        <span className="tracking-wide text-gray-300">{label}</span>
      </div>
      <div>
        <span className="text-gray-100 extrabold tracking-wide">
          {value}
        </span>
      </div>
    </div>
    <hr
      className="my-0 border-t border-gray-400"
      style={{
        backgroundImage:
          "linear-gradient(to right, #d2d6dc 50%, transparent 50%)",
        backgroundSize: "0.4rem 2px",
        backgroundRepeat: "repeat-x",
        border: "none",
        height: "1px",
      }}
    />
  </div>
);


export const getGoldProgressData = (vaultBalance: number) => {
  const capAt100 = (value: number) => Math.min(value, 100); // Helper function to cap percentage at 100

  if (vaultBalance <= 1.5) {
    // 0 to 1.5 grams, closest to 1 gram
    const percentage = capAt100(Math.round((vaultBalance / 1) * 100));
    return { completedGold: percentage, maxCompletedGold: 100, customLabelGold: `1 gm Gold Coin`, id: '1-Gram-Gold-Coin' };
  } else if (vaultBalance > 1.5 && vaultBalance < 2.5) {
    // Greater than 1.5 to less than 2.5 grams, closest to 2 grams
    const percentage = capAt100(Math.round((vaultBalance / 2) * 100));
    return { completedGold: percentage, maxCompletedGold: 100, customLabelGold: `2 gm Gold Coin`, id: '2-Gram-Gold-Coin' };
  } else if (vaultBalance >= 2.5 && vaultBalance < 5) {
    // Greater than 2.5 to less than 5 grams, closest to 5 grams
    const percentage = capAt100(Math.round(((vaultBalance) / 3) * 100));
    return { completedGold: percentage, maxCompletedGold: 100, customLabelGold: `5 gm Gold Coin`, id: '5-Gram-Gold-Coin' };
  } else if (vaultBalance >= 5 && vaultBalance < 7.5) {
    // Greater than 5 to less than 7.5 grams, closest to 5 grams
    return { completedGold: 100, maxCompletedGold: 100, customLabelGold: `5 gm Gold Coin`, id: '10-Gram-Gold-Coin' };
  } else if (vaultBalance >= 7.5 && vaultBalance < 10) {
    // Greater than 7.5 to less than 10 grams, closest to 10 grams
    const percentage = capAt100(Math.round(((vaultBalance) / 10) * 100));
    return { completedGold: percentage, maxCompletedGold: 100, customLabelGold: `10 gm Gold Coin`, id: '10-Gram-Gold-Coin' };
  } else {
    // 10 grams or more
    return { completedGold: 100, maxCompletedGold: 100, customLabelGold: `10 gm Gold Coin`, id: '10-Gram-Gold-Coin' };
  }
};


export const getSilverProgressData = (silverVaultBalance: number) => {
  const capAt100 = (value: number) => Math.min(value, 100); // Helper to cap percentage at 100

  if (silverVaultBalance <= 10.5) {
    // 0 to 10.5 grams, closest to 10 grams
    const percentage = capAt100(Math.round((silverVaultBalance / 10) * 100));
    return { completedSilver: percentage, maxCompletedSilver: 100, customLabelSilver: `10 gm Silver Coin`, SilverId: '10-Gram-Silver-Coin' };
  } else if (silverVaultBalance > 10.5 && silverVaultBalance < 20.5) {
    // Greater than 10.5 to less than 20.5 grams, closest to 20 grams
    const percentage = capAt100(Math.round((silverVaultBalance / 20) * 100));
    return { completedSilver: percentage, maxCompletedSilver: 100, customLabelSilver: `20 gm Silver Coin`, SilverId: '20-Gram-Silver-Coin' };
  } else if (silverVaultBalance >= 20.5 && silverVaultBalance < 50) {
    // Greater than 20.5 to less than 50 grams, closest to 50 grams
    const percentage = capAt100(Math.round(((silverVaultBalance) / 50) * 100));
    return { completedSilver: percentage, maxCompletedSilver: 100, customLabelSilver: `50 gm Silver Coin`, SilverId: '50-Gram-Silver-Coin' };
  } else if (silverVaultBalance >= 50 && silverVaultBalance < 75) {
    // Greater than 50 to less than 75 grams, closest to 50 grams
    return { completedSilver: 100, maxCompletedSilver: 100, customLabelSilver: `50 gm Silver Coin`, SilverId: '50-Gram-Silver-Coin' };
  } else if (silverVaultBalance >= 75 && silverVaultBalance < 100.5) {
    // Greater than 75 to less than 100.5 grams, closest to 100 grams
    const percentage = capAt100(Math.round(((silverVaultBalance) / 100) * 100));
    return { completedSilver: percentage, maxCompletedSilver: 100, customLabelSilver: `100 gm Silver Coin`, SilverId: '100-Gram-Silver-Coin' };
  } else {
    // 100 grams or more
    return { completedSilver: 100, maxCompletedSilver: 100, customLabelSilver: `100 gm Silver Coin`, SilverId: '100-Gram-Silver-Coin' };
  }
};


// Tracking of Shipment
export const processTrackingData = (rawData: any) => {
  const statuses = [
    { key: "Soft data", title: "Order Confirmed", description: 'Your Order has been Confirmed', tooltipId: '1' },
    { key: "RTO Lock", title: "Cancelled", description: 'Your Order has been Cancelled', tooltipId: '0' },
    { key: "Pick", title: "Order Picked Up", description: 'Your Order has been Picked Up', tooltipId: '2' },
    { key: "In-Transit", title: "On its way", description: 'In Transit', tooltipId: 'my-tooltip-children-multiline' },
    { key: "out for delivery", title: "Out for Delivery", description: 'Shipment out for delivery', tooltipId: '4' },
    { key: "delivered", title: "Delivered", description: 'Shipment delivered', tooltipId: '5' },
  ];

  // Check if "RTO Lock" status exists in rawData
  const rtoEntry = rawData.find((item: any) =>
    item.status.toLowerCase().includes("rto lock")
  );

  // If "RTO Lock" is found, return only the "Cancelled" status
  if (rtoEntry) {
    return {
      trackingData: [
        {
          title: "Order Confirmed",
          date: rtoEntry.updated_on.trim(),
          isCompleted: true,
          description: "Your Order has been confirmed.",
          tooltipId: '1',
        },
        {
          title: "Cancelled",
          date: rtoEntry.updated_on.trim(),
          isCompleted: false,
          description: "Your Order has been Cancelled",
          tooltipId: '0',
        },
      ],
      transitCities: [],
    };
  }

  // Process tracking statuses with specific handling for "In-Transit"
  const trackingData = statuses.map((status) => {
    const entry = rawData.find((item: any) =>
      item.status.toLowerCase().includes(status.key.toLowerCase())
    );

    const trackingStatusList = rawData.map(update => update.status.toLowerCase());
    const isCompletedStatus = trackingStatusList.some(trackingStatus =>
      trackingStatus.startsWith(status.key.toLowerCase())
    );

    // Always set isCompleted to true for "In-Transit"
    const isCompleted = status.key === "In-Transit" || !!isCompletedStatus;

    return {
      title: status.title,
      date: entry ? entry.updated_on.trim() : null,
      isCompleted,
      description: status.description,
      tooltipId: status.tooltipId,
    };
  });

  // Collect cities from entries that do not match any status key, ensuring each city appears only once
  const statusKeys = statuses.map((status) => status.key.toLowerCase());
  const uniqueCities = new Set();
  const transitCities = rawData
    .filter((item: any) => !statusKeys.some((key) => item.status.toLowerCase().includes(key)))
    .filter((item: any) => {
      const isUnique = !uniqueCities.has(item.city_name);
      if (isUnique) uniqueCities.add(item.city_name);
      return isUnique;
    })
    .map((item: any) => ({
      cityName: item.city_name,
      date: item.updated_on.trim(),
    }));

  return { trackingData, transitCities };
};